import { Pipe, PipeTransform } from '@angular/core';
import { TrackingPageFont } from '../tracking-page/tracking-page.model';

@Pipe({
  name: 'fontFamily',
  pure: true
})
export class FontFamilyPipe implements PipeTransform {
  transform(
    fontConfig: TrackingPageFont,
    only?: 'fontFamily' | 'color'
  ): {
    color?: string;
    fontFamily?: string;
    fontStyle?: string;
    fontWeight?: string | number;
  } {
    if (!fontConfig) {
      return {};
    }
    const fontStyle = {
      fontWeight: isNaN(Number(fontConfig.font?.fontStyle?.slice(0, 3)))
        ? 'normal'
        : Number(fontConfig.font?.fontStyle?.slice(0, 3)),
      fontStyle: fontConfig.font?.fontStyle?.includes('italic')
        ? 'italic'
        : 'normal'
    };
    if (!only) {
      return {
        color: fontConfig.font.fontColor,
        fontFamily: fontConfig.font.customFontUsed
          ? `"${fontConfig.font.customFontName}"`
          : fontConfig.font.fontFamily,
        ...fontStyle
      };
    }

    if (only === 'color') {
      return { color: fontConfig.font.fontColor };
    }

    return {
      fontFamily: fontConfig.font.customFontUsed
        ? `"${fontConfig.font.customFontName}"`
        : fontConfig.font.fontFamily,
      ...fontStyle
    };
  }
}
